
namespace TabAurous.ECommerce {

    import fld = OrderProcessingRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OrderProcessingForOthersGrid extends _Ext.GridBase<OrderProcessingRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderProcessing'; }
        protected getDialogType() { return OrderProcessingDialog; }
        protected getIdProperty() { return OrderProcessingRow.idProperty; }
        protected getInsertPermission() { return OrderProcessingRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProcessingRow.localTextPrefix; }
        protected getService() { return OrderProcessingService.baseUrl; }
        private pendingChanges: Q.Dictionary<any> = {};
        public rowSelection: Serenity.GridRowSelectionMixin;

        public RateListId: number = 0;
        public LaborListId: number = 0;
        public StoneMarkup: number = 0;
        public LaborMarkup: number = 0;
        constructor(container: JQuery, param: number = 4) {
            super(container, param);
            var status = parseInt(param.toString());
            if (q.isNumber(status))
                (this.view.params as TransactionRequest).OrderStatusId = status;
            this.setTitle("");
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }
        protected getColumns() {
            var columns = super.getColumns();
       
            let shipColumn = Q.first(columns, x => x.field == "ShipOrder");

            shipColumn.format = ctx => {
                if (ctx.item.TypeDescription == "Ready to Ship")
                    return '<button class="inline-action add-button ship-order" href="#" style="background-color:#228B22;color:white;width:100%;height: 30px;"><span></span>Ship Order</button>';
                else if (ctx.item.TypeDescription == "In Stock")
                    return '<button class="inline-action add-button invoice-pending" href="#" style="background-color:#228B22;color:white;width:100%;height: 30px;"><span></span>Invoice Pending</button>';
                else
                    return '';
            }
            //let selectcolumn = Q.first(columns, x => x.field == "__select__");
            //selectcolumn.width = 10;

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('ship-order')) {
                    var dialog = new Common.ShipperSelectDialog();
                    dialog.entity = item;


                    dialog.element.on('dialogclose', () => {

                        this.refresh();
                    });
                    dialog.dialogOpen();
                }
                if (target.hasClass('invoice-pending')) {
                    var salesdialog = new ECommSalesForOrderDialog();
                    var CompanyDetails = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
                    if (CompanyDetails.IsPriceList) {
                        this.RateListId = CompanyDetails.SPriceListId || 0;
                        this.StoneMarkup = CompanyDetails.SMarkup || 0;
                    }

                    if (CompanyDetails.IsLabourList) {
                        this.LaborListId = CompanyDetails.SLabourListId || 0;
                        this.LaborMarkup = CompanyDetails.SLMarkup || 0;
                    }
                    let orderaddress;
                    var items = [];
                    var orderdetails = ECommOrderService.Retrieve({ EntityId: item.TransId },
                        response => {
                            orderaddress = response.Entity.AddressDetails
                        }, { async: false });
                    let stockitem;

                    Stock.StockItemService.GetOrderStock({
                        Line_No: item.Line_No,
                    },
                        response =>
                            stockitem = response.Entity,
                        { async: false }
                    );

                    items.push(stockitem);
                    var salesitems = ItemGridHelper.SetEcommerceInvoiceItem(items, item.ECommOrderItemId);
                    //salesitems[0].OrderAmount = item.GrossAmount;
                    salesitems[0].ECommOrderItemId = item.ECommOrderItemId;
                    let now = new Date();
                    var salesvoucher: ECommSalesRow = {
                        VoucherNo: FormatHelper.GetVoucherNo(87),

                        VoucherTypeId: 87,
                        CompanyId: Q.Authorization.userDefinition.CompanyId,
                        FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                        UserId: Q.Authorization.userDefinition.UserId,
                        CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                        POSCustomerId: item.PartyId,
                        CustomerName: item.CustomerName,
                        Mobile: item.Mobile,
                        Email: item.Email,
                        TransDate: now.toDateString(),
                        ItemDetails: salesitems,
                        AddressDetails: orderaddress,
                        ECommOrderNo: item.ECommOrderNo,
                        ECommOrderId: item.ECommOrderId,
                    }

                    salesdialog.loadEntityAndOpenDialog(salesvoucher, false);

                    salesdialog.element.on('dialogclose', () => {

                        this.refresh();
                    });
                    salesdialog.dialogOpen();
                }


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var btns = super.getButtons();
            btns.pop(); 
            btns = btns.filter(x => x.cssClass != "add-button");

            btns.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            return btns;

        }
    }
}